import { z } from 'zod';
import type { AparatoSistema } from './tipos.js';

/**
 * Estadísticas operativas del Operador: volumen de controles por día de la
 * semana / mes / semana del año, y aparato/sistema afectado (patología laboral,
 * no diagnóstico) cruzado por mes y por día de semana — sirve para detectar
 * estacionalidad (ej. respiratorio en invierno) y picos de carga operativa.
 */

const fechaIso = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha (AAAA-MM-DD) inválida');

export const esquemaFiltroEstadisticas = z
  .object({
    desde: fechaIso,
    hasta: fechaIso,
    empresaId: z.string().min(1).optional(),
  })
  .superRefine((p, ctx) => {
    if (p.desde > p.hasta)
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['hasta'],
        message: 'La fecha "hasta" no puede ser anterior a "desde"',
      });
  });

export type FiltroEstadisticasInput = z.infer<typeof esquemaFiltroEstadisticas>;

export interface ConteoDTO {
  clave: string;
  cantidad: number;
}

export interface ConteoAparatoDTO {
  clave: AparatoSistema;
  nombre: string;
  cantidad: number;
}

/** Fila lista para graficar: `clave` es la categoría (día/mes) + una columna por cada aparato presente en los datos. */
export type FilaCruceAparato = { clave: string } & Record<string, number | string>;

export interface EstadisticasDTO {
  periodo: { desde: string; hasta: string };
  totalControles: number;
  totalConPatologia: number;
  porDiaSemana: ConteoDTO[];
  porMes: ConteoDTO[];
  porSemanaAnio: ConteoDTO[];
  porAparato: ConteoAparatoDTO[];
  aparatosPresentes: { clave: AparatoSistema; nombre: string }[];
  patologiaPorMes: FilaCruceAparato[];
  patologiaPorDiaSemana: FilaCruceAparato[];
}
